import { render, staticRenderFns } from "./IdcardModuleSettingComponent.vue?vue&type=template&id=782c4d98&scoped=true&"
import script from "./IdcardModuleSettingComponent.vue?vue&type=script&lang=js&"
export * from "./IdcardModuleSettingComponent.vue?vue&type=script&lang=js&"
import style0 from "./IdcardModuleSettingComponent.vue?vue&type=style&index=0&id=782c4d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782c4d98",
  null
  
)

export default component.exports